import React from 'react';

import {
    AudioIcon,
    CodeIcon,
    ExcelIcon,
    GenericIcon,
    ImageIcon,
    PatchIcon,
    PdfIcon,
    PptIcon,
    TextIcon,
    VideoIcon,
    WordIcon,
} from '@time-webkit/all/icons/file-thumbnails';

import {FILE_TYPES, IMAGE_TYPE_GIF} from '@time-webkit/all/utils/attachments';

import {getFileType} from '../../../utils/attachments/utils';

import styles from './styles.module.css';

const FILE_THUMBNAILS_MAP: Record<string, React.FunctionComponent<{ size?: { width: number; height: number } }>> = {
    text: TextIcon,
    audio: AudioIcon,
    video: VideoIcon,
    spreadsheet: ExcelIcon,
    presentation: PptIcon,
    pdf: PdfIcon,
    code: CodeIcon,
    word: WordIcon,
    patch: PatchIcon,
    other: GenericIcon,
    image: ImageIcon,
};

type Props = {
    enableSVGs?: boolean;
    fileInfo: {
        id: string;
        width: number;
        height: number;
        extension: string;
        has_preview_image?: boolean;
    };
    getFileUrl: (id: string) => string;
    getThumbnailUrl: (id: string) => string;
};

export const FileThumbnail = ({fileInfo, getThumbnailUrl, enableSVGs, getFileUrl}: Props) => {
    const type = getFileType(fileInfo.extension);
    let src = null;

    const isImageWithPreview = type === FILE_TYPES.IMAGE && fileInfo.has_preview_image;
    const isGIF = fileInfo.extension === IMAGE_TYPE_GIF;
    const isSVGEnabled = fileInfo.extension === FILE_TYPES.SVG && enableSVGs;

    if (isImageWithPreview) {
        src = getThumbnailUrl(fileInfo.id);
    } else if (isGIF || isSVGEnabled) {
        src = getFileUrl(fileInfo.id);
    }

    if (src) {
        return <img alt='file thumbnail' className={styles.fileThumbnailImage} src={src} />;
    }

    const IconComponent = (FILE_THUMBNAILS_MAP[type.toLowerCase()] || FILE_THUMBNAILS_MAP.other) as React.JSXElementConstructor<unknown>;

    return (
        <div className={styles.fileThumbnail}>
            <IconComponent />
        </div>
    );
};
